const pageData = [
    {
        id: 'about',
        title: 'RikVerse Author page',
        tabTitle: 'RikVerse Author page',
        description: 'Details about Rik Roots',
    }, 
    {
        id: 'blog',
        title: 'RikVerse blog index',
        tabTitle: 'RikVerse blog index',
        description: 'Blog post listings and links',
    }, 
    {
        id: 'support',
        title: 'Support the RikVerse',
        tabTitle: 'RikVerse Support',
        description: 'Support the RikVerse',
    }, 
    {
        id: 'error',
        title: 'RikVerse Error',
        tabTitle: 'RikVerse Error',
        description: 'Failed to find page, or load page resources',
    }, 
    {
        id: 'index',
        title: 'RikVerse Poems index',
        tabTitle: 'RikVerse Poems index',
        description: 'Listing poems written by Rik Roots',
    }, 
    {
        id: 'poem',
        title: 'RikVerse Poems index',
        tabTitle: 'RikVerse Poems index',
        description: 'Listing poems written by Rik Roots',
    }, 
    {
        id: 'privacy-and-security',
        title: 'RikVerse Security and Privacy',
        tabTitle: 'RikVerse Security and Privacy',
        description: 'Detailing the security and privacy provisions made by the RikVerse website',
    }, 
    {
        id: 'publications',
        title: 'RikVerse Books index',
        tabTitle: 'RikVerse Books index',
        description: 'Listing books written by Rik Roots',
    }, 
    {
        id: 'book',
        title: 'RikVerse Books index',
        tabTitle: 'RikVerse Books index',
        description: 'Listing books written by Rik Roots',
    }, 
    {
        id: 'read',
        title: 'RikVerse Books index',
        tabTitle: 'RikVerse Books index',
        description: 'Listing books written by Rik Roots',
    } 
];

export default pageData;
